// Меко изтритите продукти (org `products.deleted_at`) във FE: `useProducts` ги
// носи с `deleted: true`, за да има име, мярка и ДДС за всеки ред от историята
// (документи, справки, складова карта). ИЗБОРЪТ за нов ред — търсачките,
// „Целият списък", темплейтът, взаимозаменяемите — минава през
// `pickableProducts` и тях ги няма. Инвентаризацията е изключението
// (`stocktakeProducts`): изтрит продукт с наличност в склада остава за броене —
// иначе стоката му нямаше как да се нулира.
import type { Product } from "../../../../api/inventory";

export const isDeletedProduct = (product: Pick<Product, "deleted"> | null | undefined): boolean =>
  product?.deleted === true;

// Списъкът за ИЗБОР — без изтритите. Същият масив, ако няма изтрити (стабилен за memo).
export const pickableProducts = (products: Product[]): Product[] =>
  products.some(isDeletedProduct) ? products.filter((product) => !isDeletedProduct(product)) : products;

// Редовете на инвентаризацията: живите + изтритите, които още имат наличност в
// склада (≠ 0 — броенето я нулира) или са в редактирания документ (иначе
// записът би изпуснал реда им).
export const stocktakeProducts = (
  products: Product[],
  quantityOf: (productId: number) => number,
  inDocument: (productId: number) => boolean,
): Product[] =>
  products.some(isDeletedProduct)
    ? products.filter(
        (product) => !isDeletedProduct(product) || quantityOf(product.id) !== 0 || inDocument(product.id),
      )
    : products;
